/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */
import React from 'react'
import DistChart from './ChartComponents/Distribution'
import PropTypes from 'prop-types'
import List from '../../../components/List'
import DownCarat from '../../../assets/icons/carat.svg'

class Strength extends React.Component {
  constructor(props) {
    super(props)

    // getinitialState
    this.state = {
      dominant: this.DominantHand(),
      nondominant: this.NonDominantHand()
    }
  }

  UNSAFE_componentWillReceiveProps() {
    this.setState({
      dominant: this.DominantHand(),
      nondominant: this.NonDominantHand()
    })
  }

  DominantHand() {
    const { details } = this.props
    let stats = details.dominant

    /* eslint-disable @typescript-eslint/camelcase */
    return {
      display_label: stats.display_label,
      unit: stats.unit,
      value: stats.value,
      interpretation: stats.interpretation,
      percentile: stats.percentile,
      ranges: stats.ranges,
      test_name: stats.test_name,
      density_plot: stats.density_plot
    }
    /* eslint-enable @typescript-eslint/camelcase */
  }

  NonDominantHand() {
    const { details } = this.props
    let stats = details.non_dominant
    /* eslint-disable @typescript-eslint/camelcase */
    return {
      display_label: stats.display_label,
      unit: stats.unit,
      value: stats.value,
      interpretation: stats.interpretation,
      percentile: stats.percentile,
      ranges: stats.ranges,
      test_name: stats.test_name,
      density_plot: stats.density_plot
    }
    /* eslint-enable @typescript-eslint/camelcase */
  }

  render() {
    const { index, details, hotload } = this.props

    const items = {
      physicalActivity: {
        title: '<h2 class="mobile-padding">Strength</h2>',
        icon: { src: DownCarat },
        isShowAccordianOnMobile: true,
        accordianContent: `
      <div class="mobile-padding">
            <div>
              <p class="noMarginPadding">
               Strength is the capacity of a muscle to produce the tension and
            power necessary for maintaining posture, initiating or controlling
            movement.
            <br />
            <br />
            Grip strength is a good indicator of overall strength and is highly
            predictive of future functional limitations and disability.
              </p>
            </div>
              <br/>
          </div>`
      }
    }
    const listProps = {
      items,
      isMobile: this.props.isMobile,
      isNoTopBorder: true,
      isNotSpacer: true,
      isCollapsedDark: true,
      isReportStyle: true
    }

    return (
      <div className="strength-content module-content">
        <div className="intro-zone">
          {this.props.isMobile ? (
            <List {...listProps} />
          ) : (
            <p>
              Strength is the capacity of a muscle to produce the tension and
              power necessary for maintaining posture, initiating or controlling
              movement.
              <br />
              <br />
              Grip strength is a good indicator of overall strength and is
              highly predictive of future functional limitations and disability.
            </p>
          )}
        </div>
        {hotload ? (
          <div className="mobile-padding">
            {!this.props.isMobile && <hr />}
            <div className="bucket">
              <div className="table">
                <div className="trow dominant">
                  <div className="td even-width">
                    <strong className="subject">
                      {details.dominant.display_label}
                    </strong>
                  </div>
                  <div className="td even-width">
                    <strong className="value">{details.dominant.value}</strong>
                    <span className="descriptor">Score</span>
                  </div>
                  <div className="td even-width">
                    <strong className="value">
                      {details.dominant.percentile}%
                    </strong>
                    <span className="descriptor">Percentile</span>
                  </div>
                  <div className="td">
                    <DistChart
                      label={'DomStrength'}
                      details={details}
                      index={index}
                      data={this.state.dominant}
                    />
                  </div>
                </div>
              </div>
              {!details.dominant.__ok ? (
                <div className="no-report-data">
                  {`No ${details.dominant.display_label} Data Available`}
                </div>
              ) : null}
            </div>
            <hr />
            <div className="bucket">
              <div className="table">
                <div className="trow nondominant">
                  <div className="td even-width">
                    <strong className="short-subject subject">
                      {details.non_dominant.display_label}
                    </strong>
                  </div>
                  <div className="td even-width">
                    <strong className="value">
                      {details.non_dominant.value}
                    </strong>
                    <span className="descriptor">Score</span>
                  </div>
                  <div className="td even-width">
                    <strong className="value">
                      {details.non_dominant.percentile}%
                    </strong>
                    <span className="descriptor">Percentile</span>
                  </div>
                  <div className="td">
                    <DistChart
                      label={'NonDomStrength'}
                      details={details}
                      index={index}
                      data={this.state.nondominant}
                    />
                  </div>
                </div>
              </div>
              {!details.non_dominant.__ok ? (
                <div className="no-report-data">
                  {`No ${details.non_dominant.display_label} Data Available`}
                </div>
              ) : null}
            </div>
          </div>
        ) : null}
      </div>
    )
  }
}

Strength.propTypes = {
  details: PropTypes.object.isRequired
}

export default Strength
